import { Directive, OnInit, inject, input } from '@angular/core';

import { ThemeBorder, ThemeBorderRadius, ThemeElevated, ThemeInverse, injectCurrentTheme } from '@frontend/sports/common/ui/shared';
import { DsCard } from '@frontend/ui/card';

import { CardThemeSurface } from './types';

@Directive({
    selector: '[msThemedCard]',
})
export class SportsThemedCardDirective implements OnInit {
    themedInverse = input<ThemeInverse>();
    themedCardSurface = input<CardThemeSurface>();
    themeCardElevated = input<ThemeElevated>();
    themeBorderRadius = input<ThemeBorderRadius>();
    themeBorder = input<ThemeBorder>();

    currentTheme = injectCurrentTheme();
    card: DsCard = inject(DsCard, {
        self: true,
    });

    ngOnInit(): void {
        const inverse = this.themedInverse()?.[this.currentTheme];
        if (inverse) {
            this.card.inverse.set(inverse.isInverse);
        }

        const surface = this.themedCardSurface()?.[this.currentTheme];
        if (surface) {
            this.card.surface.set(surface);
        }

        const elevated = this.themeCardElevated()?.[this.currentTheme];
        if (elevated) {
            this.card.elevated.set(elevated.isElevated);
        }

        const borderRadius = this.themeBorderRadius()?.[this.currentTheme];
        if (borderRadius) {
            this.card.radius.set(borderRadius.hasRadius);
        }

        const border = this.themeBorder()?.[this.currentTheme];
        if (border) {
            this.card.border.set(border.hasBorder);
        }
    }
}
